import React, { useEffect } from 'react'
import { Grid } from "@mui/material"

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { BACKEND_APIS } from "@constants"
import { offices, reports } from "@signals"
import { setLastOfficeSubmitted } from "Pages/ReportsAlerts/Alerts/Notifications/@signals"
import { alertsSection, isRatingTabLoading, isRatingTabEmpty } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { conditionNameColumn, ratingColumn } from "Pages/ReportsAlerts/Alerts/Notifications/Rating/columns"
import { comparatorColumn, siteColumn } from "Pages/ReportsAlerts/Alerts/Notifications/@components"
import { batch } from "@preact/signals-react"
import { isTourDemoActive } from "@signals/app"
import { dsColorNew } from "@palette"


export default function RatingBlock() {

	const { getTableData, tableData, isTableLoading, filterConditions } = useAlertsTableData(`${BACKEND_APIS.NOTIFICATIONS}/rating`)

	useEffect(() => {
		if (!!offices.value && !!reports.value) {
			isRatingTabLoading.value = true
			isRatingTabEmpty.value = false
			getTableData({
				idReportExecution: reports.value,
				idOfficePickup: offices.value
			}).then(data => { isRatingTabEmpty.value = !data?.length })
				.finally(() => batch(() => {
					isRatingTabLoading.value = false
					setLastOfficeSubmitted()
				}))
		}
	}, [reports.value, offices.value])

	if (alertsSection.value !== ALERTS.RATING) return <></>
	if (isTourDemoActive.value && !tableData?.length) return <></>

	return <Grid item xs={12}>
		<AlertsBaseTable
			title="Notifications: Rating"
			data={tableData}
			isLoading={isTableLoading}
			filterConditions={filterConditions}
			columns={[
				conditionNameColumn(),
				...siteColumn(),
				...comparatorColumn("provider", "Provider"),
				ratingColumn()
			]}
			legend={[
				{ icon: "less-than", value: "Lower", label: "Less than", iconProps: { color: dsColorNew.dangerRed } },
				{ icon: "not-equal", value: "Different", label: "Different than", iconProps: { color: dsColorNew.noteAmber } },
				{ icon: "greater-than", value: "Higher", label: "Greater than", iconProps: { color: dsColorNew.successText } },
				{ icon: "star-sharp", label: "Rating Score", iconProps: { color: dsColorNew.noteAmber } },
			]}
		/>
	</Grid>
}